import { useTheme } from '@mui/material';

interface ServerErrorIllustrationProps {
  width?: number | string;
  height?: number | string;
}

const ServerErrorIllustration = ({ width = 150, height = 150 }: ServerErrorIllustrationProps) => {
  const { palette } = useTheme();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 150 150"
      fill="none"
      style={{ display: 'block' }}
    >
      <rect
        x="7.6126"
        y="34.7001"
        width="114.6"
        height="113.6"
        rx="10.219"
        fill={palette.custom.border.primary}
        stroke={palette.custom.border.primary}
        strokeWidth="1.4"
      />
      <rect
        x="1.4126"
        y="28.005"
        width="117.744"
        height="117.744"
        rx="10.419"
        fill={palette.background.paper}
        stroke={palette.accent.main}
      />
      <path
        d="M11.8315 28.005H108.738C114.492 28.0053 119.157 32.6699 119.157 38.424V47.4777H1.4126V38.424C1.41261 32.6697 6.07732 28.005 11.8315 28.005Z"
        fill={palette.action.hover}
        stroke={palette.accent.main}
      />
      <path
        d="M13.0748 42.2748C15.2689 42.2748 17.0476 40.4961 17.0476 38.302C17.0476 36.1079 15.2689 34.3292 13.0748 34.3292C10.8807 34.3292 9.10205 36.1079 9.10205 38.302C9.10205 40.4961 10.8807 42.2748 13.0748 42.2748Z"
        fill={palette.text.tertiary}
      />
      <path
        d="M25.0013 42.2748C27.1954 42.2748 28.9741 40.4961 28.9741 38.302C28.9741 36.1079 27.1954 34.3292 25.0013 34.3292C22.8072 34.3292 21.0286 36.1079 21.0286 38.302C21.0286 40.4961 22.8072 42.2748 25.0013 42.2748Z"
        fill={palette.divider}
      />
      <path
        d="M36.9372 42.2748C39.1313 42.2748 40.91 40.4961 40.91 38.302C40.91 36.1079 39.1313 34.3292 36.9372 34.3292C34.7431 34.3292 32.9644 36.1079 32.9644 38.302C32.9644 40.4961 34.7431 42.2748 36.9372 42.2748Z"
        fill={palette.background.paper}
      />
      <path
        d="M43.6921 73.0939H13.7306C11.3357 73.0939 9.39429 75.0353 9.39429 77.4301C9.39429 79.825 11.3357 81.7664 13.7306 81.7664H43.6921C46.087 81.7664 48.0284 79.825 48.0284 77.4301C48.0284 75.0353 46.087 73.0939 43.6921 73.0939Z"
        fill={palette.divider}
      />
      <path
        d="M101.156 93.3859H12.066C10.5905 93.3859 9.39429 94.582 9.39429 96.0576C9.39429 97.5332 10.5905 98.7293 12.066 98.7293H101.156C102.631 98.7293 103.827 97.5332 103.827 96.0576C103.827 94.582 102.631 93.3859 101.156 93.3859Z"
        fill={palette.divider}
      />
      <path
        d="M80.8525 106.819H12.066C10.5905 106.819 9.39429 108.016 9.39429 109.491C9.39429 110.967 10.5905 112.163 12.066 112.163H80.8525C82.3281 112.163 83.5243 110.967 83.5243 109.491C83.5243 108.016 82.3281 106.819 80.8525 106.819Z"
        fill={palette.divider}
      />
      <mask id="serverErrorIllustrationMask0" fill="white">
        <path d="M115.5 2.99988C134.05 3.00003 149.087 15.8447 149.087 31.6893C149.087 47.5339 134.05 60.3786 115.5 60.3788C113.247 60.3788 111.045 60.1876 108.916 59.826L102.385 65.0214C101.028 66.1009 99.0201 65.1844 98.9468 63.452L98.6528 56.5126C88.6434 51.5455 81.9127 42.2893 81.9126 31.6893C81.9126 15.8447 96.9506 2.99988 115.5 2.99988Z" />
      </mask>
      <path
        d="M115.5 2.99988C134.05 3.00003 149.087 15.8447 149.087 31.6893C149.087 47.5339 134.05 60.3786 115.5 60.3788C113.247 60.3788 111.045 60.1876 108.916 59.826L102.385 65.0214C101.028 66.1009 99.0201 65.1844 98.9468 63.452L98.6528 56.5126C88.6434 51.5455 81.9127 42.2893 81.9126 31.6893C81.9126 15.8447 96.9506 2.99988 115.5 2.99988Z"
        fill={palette.custom.border.primary}
      />
      <path
        d="M115.5 2.99988L115.5 2.20472H115.5V2.99988ZM149.087 31.6893L149.883 31.6893V31.6893H149.087ZM115.5 60.3788V61.1739H115.5L115.5 60.3788ZM108.916 59.826L109.049 59.0421L108.698 58.9827L108.42 59.2038L108.916 59.826ZM102.385 65.0214L101.89 64.3991L101.89 64.3991L102.385 65.0214ZM98.9468 63.452L99.7412 63.4184V63.4184L98.9468 63.452ZM98.6528 56.5126L99.4473 56.4789L99.4274 56.0093L99.0063 55.8003L98.6528 56.5126ZM81.9126 31.6893H81.1174V31.6893L81.9126 31.6893ZM115.5 2.99988L115.5 3.79504C133.733 3.79519 148.292 16.3968 148.292 31.6893H149.087H149.883C149.883 15.2927 134.367 2.20487 115.5 2.20472L115.5 2.99988ZM149.087 31.6893L148.292 31.6893C148.292 46.9818 133.733 59.5835 115.5 59.5836L115.5 60.3788L115.5 61.1739C134.367 61.1738 149.882 48.0859 149.883 31.6893L149.087 31.6893ZM115.5 60.3788V59.5836C113.292 59.5836 111.134 59.3962 109.049 59.0421L108.916 59.826L108.782 60.61C110.955 60.9789 113.202 61.1739 115.5 61.1739V60.3788ZM108.916 59.826L108.42 59.2038L101.89 64.3991L102.385 65.0214L102.88 65.6436L109.411 60.4483L108.916 59.826ZM102.385 65.0214L101.89 64.3991C101.042 65.0739 99.787 64.501 99.7412 63.4184L98.9468 63.452L98.1523 63.4856C98.2531 65.8679 101.015 67.1278 102.88 65.6436L102.385 65.0214ZM98.9468 63.452L99.7412 63.4184L99.4473 56.4789L98.6528 56.5126L97.8584 56.5462L98.1523 63.4857L98.9468 63.452ZM98.6528 56.5126L99.0063 55.8003C89.2117 50.9399 82.7078 41.9297 82.7078 31.6893L81.9126 31.6893L81.1174 31.6893C81.1175 42.6489 88.0751 52.1512 98.2994 57.2249L98.6528 56.5126ZM81.9126 31.6893H82.7078C82.7078 16.3968 97.2676 3.79504 115.5 3.79504V2.99988V2.20472C96.6337 2.20472 81.1174 15.2925 81.1174 31.6893H81.9126Z"
        fill={palette.custom.border.primary}
        mask="url(#serverErrorIllustrationMask0)"
      />
      <mask id="serverErrorIllustrationMask1" fill="white">
        <path d="M114.017 0.999878C132.566 1.00006 147.604 13.8448 147.604 29.6893C147.603 45.5338 132.566 58.3786 114.017 58.3788C111.763 58.3788 109.56 58.1867 107.431 57.8251L100.901 63.0214C99.5445 64.1009 97.5362 63.1844 97.4629 61.452L97.1689 54.5126C87.1595 49.5455 80.4288 40.2893 80.4287 29.6893C80.4287 13.8447 95.4667 0.999878 114.017 0.999878Z" />
      </mask>
      <path
        d="M114.017 0.999878C132.566 1.00006 147.604 13.8448 147.604 29.6893C147.603 45.5338 132.566 58.3786 114.017 58.3788C111.763 58.3788 109.56 58.1867 107.431 57.8251L100.901 63.0214C99.5445 64.1009 97.5362 63.1844 97.4629 61.452L97.1689 54.5126C87.1595 49.5455 80.4288 40.2893 80.4287 29.6893C80.4287 13.8447 95.4667 0.999878 114.017 0.999878Z"
        fill={palette.background.paper}
      />
      <path
        d="M114.017 0.999878L114.017 -0.00012207H114.017V0.999878ZM147.604 29.6893L148.604 29.6893V29.6893H147.604ZM114.017 58.3788V59.3788H114.017L114.017 58.3788ZM107.431 57.8251L107.598 56.8392L107.158 56.7644L106.808 57.0426L107.431 57.8251ZM100.901 63.0214L101.524 63.8039L101.524 63.8038L100.901 63.0214ZM97.4629 61.452L98.462 61.4098L98.462 61.4097L97.4629 61.452ZM97.1689 54.5126L98.168 54.4703L98.143 53.8796L97.6135 53.6168L97.1689 54.5126ZM80.4287 29.6893H79.4287V29.6893L80.4287 29.6893ZM114.017 0.999878L114.017 1.99988C132.168 2.00005 146.604 14.5391 146.604 29.6893H147.604H148.604C148.604 13.1505 132.965 6.13928e-05 114.017 -0.00012207L114.017 0.999878ZM147.604 29.6893L146.604 29.6893C146.603 44.8395 132.168 57.3786 114.017 57.3788L114.017 58.3788L114.017 59.3788C132.965 59.3786 148.603 46.2281 148.604 29.6893L147.604 29.6893ZM114.017 58.3788V57.3788C111.819 57.3788 109.673 57.1916 107.598 56.8392L107.431 57.8251L107.263 58.811C109.447 59.1819 111.706 59.3788 114.017 59.3788V58.3788ZM107.431 57.8251L106.808 57.0426L100.279 62.2389L100.901 63.0214L101.524 63.8038L108.053 58.6075L107.431 57.8251ZM100.901 63.0214L100.279 62.2388C99.5616 62.8094 98.5007 62.3249 98.462 61.4098L97.4629 61.452L96.4638 61.4943C96.5717 64.0439 99.5273 65.3924 101.524 63.8039L100.901 63.0214ZM97.4629 61.452L98.462 61.4097L98.168 54.4703L97.1689 54.5126L96.1698 54.5549L96.4638 61.4943L97.4629 61.452ZM97.1689 54.5126L97.6135 53.6168C87.8742 48.7838 81.4288 39.837 81.4287 29.6893L80.4287 29.6893L79.4287 29.6893C79.4288 40.7416 86.4448 50.3072 96.7244 55.4083L97.1689 54.5126ZM80.4287 29.6893H81.4287C81.4287 14.539 95.8654 1.99988 114.017 1.99988V0.999878V-0.00012207C95.0681 -0.00012207 79.4287 13.1503 79.4287 29.6893H80.4287Z"
        fill={palette.accent.main}
        mask="url(#serverErrorIllustrationMask1)"
      />
      <path
        d="M103.18 20.2052L92.9126 30.473L104.002 39.5087"
        stroke={palette.accent.main}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M118.216 19.9999L110.002 39.7141"
        stroke={palette.accent.main}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M125.037 39.5087L135.305 29.2409L124.216 20.2052"
        stroke={palette.accent.main}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ServerErrorIllustration;
